import { useState, useEffect } from "react"
import RollingCommission from "../promotions/RollingCommission"

const HeaderPromotions = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [showRolling, setShowRolling] = useState(false)

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedIn)
  }, [])

  if (!isLoggedIn) {
    return null
  }

  return (
    <>
      {/* Only render RollingCommission if showRolling is true */}
      {showRolling && (
        <RollingCommission onClose={() => setShowRolling(false)} />
      )}

      {/* Clicking this toggles showRolling */}
      <div
        className="header-promotions-btn"
        onClick={() => setShowRolling(!showRolling)}
      >
        <img
          src="/images/buttons/rolling-commission-new.webp"
          alt="Rolling Commission Button"
        />
      </div>
    </>
  )
}

export default HeaderPromotions
